<template>
  <path
    d="M9.30999 6.71021C8.91999 7.10021 8.91999 7.73021 9.30999 8.12021L13.19 12.0002L9.30999 15.8802C8.91999 16.2702 8.91999 16.9002 9.30999 17.2902C9.69999 17.6802 10.33 17.6802 10.72 17.2902L15.31 12.7002C15.7 12.3102 15.7 11.6802 15.31 11.2902L10.72 6.7002C10.34 6.3202 9.69999 6.32021 9.30999 6.71021Z"
  />
</template>
